<template>
  <div class="home">
    <div class="home-header">
      <h1>Libro Admin</h1>
      <button class="logout-button" @click="handleLogout">Cerrar sesión</button>
    </div>
    <div class="user-info" v-if="authStore.currentUser">
      <p>Bienvenido, <strong>{{ authStore.currentUser.name }}</strong></p>
      <p class="user-email">{{ authStore.currentUser.email }}</p>
    </div>
    <p class="placeholder">Panel de administración</p>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const router = useRouter();
const authStore = useAuthStore();

const handleLogout = () => {
  authStore.logout();
  router.push('/login');
};
</script>

<style scoped>
.home {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.home-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.home-header h1 {
  color: #e0e0e0;
  margin: 0;
}

.logout-button {
  background-color: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  color: #b0b0b0;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 16px;
  transition: all 0.2s;
}

.logout-button:hover {
  background-color: #3a3a3a;
  color: #e0e0e0;
}

.user-info {
  background-color: #1a1a1a;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.user-info p {
  color: #e0e0e0;
  margin: 0 0 8px 0;
}

.user-email {
  color: #b0b0b0 !important;
  font-size: 14px;
}

.placeholder {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-top: 40px;
}
</style>
